(() => {
  const createWorker = (workerUrl) => {
    const host = `${window.location.protocol}//${window.location.host}`;
    let worker = null;
    try {
      let blob;
      try {
        blob = new Blob([`importScripts('${host}${workerUrl}');`], { type: 'application/javascript' });
      } catch (e1) {
        const blobBuilder = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder)();
        blobBuilder.append(`importScripts('${host}${workerUrl}');`);
        blob = blobBuilder.getBlob('application/javascript');
      }
      const url = window.URL || window.webkitURL;
      const blobUrl = url.createObjectURL(blob);
      worker = new Worker(blobUrl);
    } catch (e2) {
      worker = new Worker(workerUrl);
    }

    return worker;
  };
  const justInTimeWorkers = {};

  const getJustInTimeWorker = (basename) => {
    if (!justInTimeWorkers[basename]) {
      let assetsBase = window.swinger.config.assetsBase;

      if (window.swinger.config.assetsBase.startsWith('./')) {
        const pathParts = window.location.pathname.split('/');
        pathParts.pop();
        assetsBase = `${pathParts.join('/')}/${window.swinger.config.assetsBase}`;
      }

      justInTimeWorkers[basename] = createWorker(`${assetsBase}/workers/${basename}${!window.swinger.supportsModules ? '.es5' : ''}.js?v=${window.swinger.config.version}`);
    }

    return justInTimeWorkers[basename];
  };
  const justInTimeWorker = (basename) => ({
    postMessage: (...theArgs) => {
      try {
        getJustInTimeWorker(basename).postMessage(...theArgs);
      } catch (e) {
        console.error(basename, e);
        console.error(basename, ...theArgs);
      }
    },
    addEventListener: (...theArgs) => {
      getJustInTimeWorker(basename).addEventListener(...theArgs);
    },
    onmessage: (...theArgs) => {
      getJustInTimeWorker(basename).onmessage(...theArgs);
    },
  });

  window.swinger = {
    ...window.swinger,
    webworker: {
      jsonWorker: justInTimeWorker('json-worker'),
      twigWorker: justInTimeWorker('twig-worker'),
      filterWorker: justInTimeWorker('filter-worker'),
      speedtestWorker: justInTimeWorker('speedtest-worker'),
    },
  };

  try {
    const hasSpeedtestBeenRun = !!window.sessionStorage.getItem('swinger.speedtest')
      || !!window.swinger.cookie.get('swinger.speedtest')
      || window.name === 'swinger.speedtest'
      || false; // This en/disables the speedtest

    if (!hasSpeedtestBeenRun) {
      window.addEventListener('load', () => {
        const speedtestWorker = window.swinger.webworker.speedtestWorker;

        speedtestWorker.addEventListener('message', (e) => {
          if (e.data.action !== 'result') {
            return;
          }

          const serverspeeds = JSON.parse(window.localStorage.getItem('swinger.serverspeeds') || window.localStorage.getItem(atob('a25wYi5zZXJ2ZXJzcGVlZHM=')) || '{}');
          const logfileUrl = `https://${e.data.server}/rand100.txt`;
          const averageMbitPerSecond = e.data.speed;

          serverspeeds[e.data.server] = e.data.speed;

          try {
            window.localStorage.setItem('swinger.serverspeeds', JSON.stringify(serverspeeds));
          } catch (e) {
            // noop
          }

          if (
            navigator.userAgent.toLowerCase().indexOf('bot') > -1
          ) {
            return;
          }

          if (
            !navigator.connection
            || !navigator.connection.effectiveType
          ) {
            return;
          }

          if (
            navigator.connection
            && navigator.connection.effectiveType
            && ['slow-2g', '2g', '3g'].indexOf(navigator.connection.effectiveType) > -1
          ) {
            return;
          }

          const xhrUrl = `${logfileUrl}?mbit=${averageMbitPerSecond}`;
          const xhr = new XMLHttpRequest();
          xhr.open('GET', xhrUrl);
          xhr.send();

          window._paq = window._paq || [];
          window._paq.push([
            'trackEvent',
            'Metrics',
            'Download Speed',
            e.data.server,
            e.data.speed,
          ]);
        });

        window[window.requestIdleCallback ? 'requestIdleCallback' : 'setTimeout'](() => {
          if (
            navigator.connection
            && navigator.connection.saveData
          ) {
            return;
          }

          speedtestWorker.postMessage({});

          try {
            window.sessionStorage.setItem('swinger.speedtest', 'true');
          } catch (e) {
            // noop
          }
          window.name = 'swinger.speedtest';
          window.swinger.cookie.set('swinger.speedtest', 'true', 86400);
        }, {
          timeout: 5000,
        });
      });
    }
  } catch (e) {
    console.trace(e);
    // noop
  }
})();
